(function() {
  'use strict';

  angular.module('ringbaPortal')
    .directive('trTargets', function() {
      return {
        restrict: 'E',
        scope: {
          mode: '@',
          jtarget:'@'
        },
        controller: 'TargetsController',
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: '/scripts/components/targets/targets.view.html'
      };
    });
})();
